astral-modal {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    height: 100%;
    width: 100%;
    background: var(--astral-text-color);
    opacity: 0.65;
    position: absolute;
    z-index: -1;
  }

  div[slot='container'] {
    justify-self: center;
    align-self: center;
    display: block;
    border-radius: 10px;
    padding: 15px;
    background: #262626;
    color: var(--astral-text-color);
  }
}
